import paths from 'app/paths';
import AisVersionList from 'components/aisVersions/AisVersionList/AisVersionList';

export default [
  {
    path: paths.aisVersions.path,
    roles: paths.aisVersions.roles,
    component: AisVersionList,
  },
];
